import type { Grid2 as Grid } from '@mui/material';
import type { ComponentProps } from 'react';
import { useValuationsStore } from '../../../store/valuationsStore';
import { Metric } from '../Metric';
import { SummaryCardContentGrid } from '../SummaryCardContentGrid';
import { useKeyInformationMetrics } from './useKeyInformationMetrics';

type KeyInformationViewProps = ComponentProps<typeof Grid> & {
  showTimeline?: boolean;
};

const KeyInformationView = ({
  showTimeline = false,
  children,
  ...props
}: KeyInformationViewProps) => {
  const selectedAssetDetails = useValuationsStore.use.selectedAssetDetails();
  const metrics = useKeyInformationMetrics(selectedAssetDetails);

  if (metrics.length === 0) {
    return null;
  }

  return (
    <>
      <SummaryCardContentGrid {...props} data-id='key-information-view'>
        {metrics.map(metric => (
          <Metric
            key={metric.label}
            label={metric.label}
            value={metric.value}
            {...(metric.unit ? { unit: metric.unit } : {})}
            {...(metric.link ? { link: metric.link } : {})}
          />
        ))}
      </SummaryCardContentGrid>
      {children}
    </>
  );
};

export { KeyInformationView };
